// Upraveno z https://github.com/angelxmoreno/axios-date-transformer/blob/main/src/index.ts
import type { AxiosResponse } from 'axios'

const dateRegex = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(?:\.\d*)?(?:[-+]\d{2}:?\d{2}|Z)?)?$/

/**
 * Determines if a given string value matches the ISO date format.
 * @param value - The value to be checked.
 * @returns `true` if the value is a valid ISO date string, otherwise `false`.
 */
const isDateString = (value: any): boolean => {
  return dateRegex.test(value)
}

/**
 * Determines if a given value should be converted to a Date object.
 * @param value - The value to be checked.
 * @returns `true` if the value should be converted, otherwise `false`.
 */
const shouldConvert = (value: any, key: string): boolean => {
  return typeof value === 'string' && isDateString(value) && !ignoredKeys.includes(key)
}

/**
 * Recursively traverses an object and converts allowed fields to Date objects.
 * @param data - The data to be traversed and transformed.
 * @returns The transformed data with Date objects where applicable.
 */
const recursiveDateConversion = (data: any): any => {
  if (typeof data === 'object') {
    for (const key in data) {
      if (shouldConvert(data[key], key)) {
        data[key] = new Date(data[key])
      } else if (typeof data[key] === 'object') {
        data[key] = recursiveDateConversion(data[key])
      }
    }
  }

  return data
}

/**
 * Transforms date strings in the Axios response data to Date objects based on the allowlist.
 * @param response - The Axios response object.
 * @returns The transformed Axios response.
 */
export const transformDates = <T = any>(response: AxiosResponse<T>): AxiosResponse<T> => {
  if (response.data) {
    response.data = recursiveDateConversion(response.data)
  }

  return response
}

let ignoredKeys: string[] = []

export const addIgnoredDateKeys = (keys: string[]): void => {
  ignoredKeys = [...ignoredKeys, ...keys]
}